import { Translatable } from "@icc/shared/helpers";

/** Uchwyt szyny górnej */
export class TopRailHolder {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    description: string;
    img: string;
    blindBoxTypesIds: number[];
    lamellaIds: number[];
    blindGuidanceIds: number[];
    availableWithoutBox: boolean;
    /** Liczba uchwytów */
    amount?: number;
    printCode?: string;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}